import { applyMiddleware, compose, createStore } from 'redux';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import thunk from 'redux-thunk';

import { baseApi } from './apis/baseApi'; // RTK base API
import { rootReducer } from './reducers';

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['linkedInImportReducer'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const middlewares = [thunk, baseApi.middleware];

const makeStore = () => {
  const store = createStore(
    persistedReducer,
    compose(
      applyMiddleware(...middlewares),
      // eslint-disable-next-line
      window.__REDUX_DEVTOOLS_EXTENSION__ ? window.__REDUX_DEVTOOLS_EXTENSION__() : (f) => f
    )
  );
  const persistor = persistStore(store);
  return { store, persistor };
};

export default makeStore;
